const rolePermit = (el, binding) => {
    if (binding.value !== "sub") {
        el.remove();
    }
};
export default rolePermit;
